import React from 'react';
import { Spinner } from 'react-bootstrap';

function LoadingSpinner() {
    return (
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
            <Spinner animation="border" role="status">
                <span className="visually-hidden">로딩 중...</span>
            </Spinner>
        </div>
    );
}

export default LoadingSpinner; 